var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreePointsDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2,
    height: 10,
    viewBox: "0 0 2 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 8C1.41421 8 1.75 8.33579 1.75 8.75C1.75 9.16421 1.41421 9.5 1 9.5C0.585786 9.5 0.25 9.16421 0.25 8.75C0.25 8.33579 0.585786 8 1 8Z",
    fill: "#010311"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 4.25C1.41421 4.25 1.75 4.58579 1.75 5C1.75 5.41421 1.41421 5.75 1 5.75C0.585786 5.75 0.25 5.41421 0.25 5C0.25 4.58579 0.585786 4.25 1 4.25Z",
    fill: "#010311"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0.5C1.41421 0.5 1.75 0.835787 1.75 1.25C1.75 1.66421 1.41421 2 1 2C0.585786 2 0.25 1.66421 0.25 1.25C0.25 0.835787 0.585786 0.5 1 0.5Z",
    fill: "#010311"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreePointsDown);
export default __webpack_public_path__ + "static/media/threePointsDown.0d9c338721f466f20160f5ce64981fa0.svg";
export { ForwardRef as ReactComponent };